import { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { supabase } from '@/integrations/supabase/client';
import { ArrowLeft } from 'lucide-react';
import { getResetPasswordUrl } from '@/utils/url';
import { TopNavigation } from '@/components/layout/TopNavigation';
import { BottomNavigation } from '@/components/layout/BottomNavigation';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const backgroundStyle = {
  background: '#160C0C'
};

export default function ResetPasswordSent() {
  const query = useQuery();
  const email = query.get('email') || '';
  const [counter, setCounter] = useState(30);
  const [loading, setLoading] = useState(false);
  const [resent, setResent] = useState(false);

  // Countdown
  useEffect(() => {
    if (counter === 0) return;
    const timer = setTimeout(() => setCounter(counter - 1), 1000);
    return () => clearTimeout(timer);
  }, [counter]);

  const handleResendEmail = async () => {
    try {
      const resetUrl = getResetPasswordUrl();
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: resetUrl,
      });

      setCounter(30);
      setResent(true);
      setLoading(false);
    } catch (error) {
      console.error('Error resending email:', error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 pt-20 pb-24 relative" style={backgroundStyle}>
      <TopNavigation />
      <div className="w-full max-w-md mt-2 mb-4 pl-2">
        <Link
          to="/"
          className="text-white/80 hover:text-white font-sans text-sm transition-colors duration-200 flex items-center gap-2 underline"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Sign In
        </Link>
      </div>
      <div className="w-full max-w-md flex-1 flex flex-col justify-center items-center">
        <div className="bg-black/40 rounded-2xl shadow-lg p-8 max-w-md w-full flex flex-col items-center relative z-0">
          <h2 className="text-2xl font-bold text-white mb-4 text-center font-sans">Password Reset E-mail sent</h2>
          <p className="text-white/80 text-center mb-6">
            We sent a password reset link to <span className="font-semibold text-white">{email}</span>.<br />
            Please check your inbox and follow the instructions.
          </p>
          <Button
            onClick={handleResendEmail}
            disabled={counter > 0 || loading}
            className="w-full bg-[#D72E16] hover:bg-[#B8251A] text-white font-medium py-4 h-14 rounded-full transition-colors duration-200 disabled:opacity-50 mb-2"
          >
            {counter > 0 ? `Resend in ${counter}s` : resent ? 'Resent! Send Again?' : 'Resend Email'}
          </Button>
        </div>
      </div>
      <BottomNavigation />
    </div>
  );
} 